// eslint-disable-next-line import/no-cycle
import QueryWhereChild from './query-where-child';

export default class QueryWhereChildren {
	/**
	 * @param {any} children
	 */
	constructor(children = null) {
		/** @type {'AND' | 'OR'} */
		this.condition = children?.condition || 'AND';

		/** @type {QueryWhereChild[]} */
		this.items = children?.items || [];
	}
}
